import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 512 512"},
  viewBox: "6 12 36 30.05"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ffc107",
      d: "M30 17c0 1-.314 2.658-.963 2 0 0-.037 3-2.037 2-1.586-.793-3-4 0-7-1 0-3.368 2.103-4 4-1 3 .339 4.192 1 6 .725 1.982 1 3 1 5 0 1.205-.55 3-2 3-3 0-1.3-3.437-1.25-4.297C21.833 26.246 21 25 20 24c1 1 .368 2.451-.333 3.039-.634.533-1.029.496-1.667-.039-1.414-1.188 0-4 1-5-1.797 1.345-3 2.695-3 5 0 3 2 6-1 7-2.562.854-2.99-4.557-2-7-2.208 2.943-2.605 4.438-2.167 7.417.385 2.614-.782 4.76-3.115 4.864 0 0 11.438 1.604 15.531-1.198s7.5-14.5 7.5-14.5z",
      "data-original": "#ffc107"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#ff3d00",
      d: "M29.037 19c.123 4.117.296 7.536-4.037 13.5-8 9-19 5.5-19 7.5s7.882 2.362 11.955 1.823C22.004 41.291 33.125 39.75 39 29a25.576 25.576 0 0 0 3-10l-7-4z",
      "data-original": "#ff3d00"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7cb342",
      d: "M42 19.5s-2-3-4 0c-2-2-3-2-5 0-2-3-4 0-4 0 0-3.59 2.063-7.5 6.875-7.5C40.625 12 42 15.91 42 19.5z",
      "data-original": "#7cb342"
    }, null, -1)
  ])))
}
export default { render: render }